import { z } from 'zod'

export const ContainerSummarySchema = z.object({
  container: z.string(),
  totalSKUs: z.number(),
  location: z.string().optional()
})

export const ContainersSummarySchema = z.array(ContainerSummarySchema)

export type ContainerSummaryType = z.infer<typeof ContainerSummarySchema>

export interface PalletSummaryData extends ContainerSummaryType {
  scanned?: boolean
}

const ProductSchema = z.object({
  containerId: z.string(),
  productZone: z.string().nullable().default('No zone'),
  imgUrl: z.string(),
  name: z.string(),
  barcode: z.string(),
  sku: z.string(),
  quantity: z.number(),
  remainingQuantity: z.number().optional(),
  processedQuantity: z.array(z.number()),
  unitsOfMeasurment: z.number(),
  measureUnit: z.string(),
  isStockOut: z.boolean()
})

export type ProductType = z.infer<typeof ProductSchema>

const ContainerSchema = z.object({
  id: z.string(),
  products: z.array(ProductSchema),
  totalSKUs: z.number(),
  location: z.string().optional()
})

export type ContainerType = z.infer<typeof ContainerSchema>

export const OrderDetailSchema = z.object({
  toWarehouse: z.string(),
  transferId: z.string(),
  containers: z.array(ContainerSchema),
  pickedFinished: z.boolean().optional()
})

export const OrderDetailSummarySchema = z.object({
  status: z.string().optional(),
  summarizedContainers: ContainersSummarySchema,
  pickedFinished: z.boolean().optional()
})

export type OrderDetailSummaryType = z.infer<typeof OrderDetailSummarySchema>

export type OrderDetailType = z.infer<typeof OrderDetailSchema>

export const ProductQuantitiesSchema = z.object({
  ean: z.string(),
  quantity: z.array(z.number()).optional(),
  destinationContainer: z.array(z.string()).optional(),
  originContainer: z.array(z.string()).optional(),
  location: z.array(z.string()).optional(),
  missingQuantity: z.number().optional(),
  wasteQuantity: z.number().optional()
})

export type ProductQuantitiesType = z.infer<typeof ProductQuantitiesSchema>

export interface RegisterQuantitiesData {
  ean: string
  quantity: number[]
  location: string
  destinationContainer: string
}

export interface PreparationPalletData {
  container: string
  productCount: number
  location: string
  currentPallet?: boolean
  palletScanned?: boolean
  palletReady?: boolean
}

export interface TransferPalletData {
  container: string
  channel: string
  currentPallet?: boolean
  palletScanned?: boolean
  palletReady?: boolean
}

export interface UpdateOrderStatusResponse {
  id: string
  orderStatus: string
}

export interface PalletLabelData {
  docNum: string
  warehouse: string
  palletNumber: number
  totalPallets: number
  container: string
  totalSKUs: number
  printDate: string
  userName: string
  productsZone: string
  isStockOut?: boolean
}

export interface CreateOrderSubscriptionData {
  docNum: string
  subscription: PushSubscription
}
